<template>
  <div :role="role" :aria-labelledby="labelledBy">
    <div v-for="(option, i) in options">
      <IntControlField :id="'group-option-' + name + '-' + i"
                       :name="name"
                       :type="type"
                       :option="option"
                       :checked="value.includes(option.value)"
                       @update:checked="onChecked(option.value, $event)"
                       :disabled="disabled"
                       :ignore-validation="true" />
    </div>
  </div>
</template>

<script>
  import IntControlField from './index'
  
  export default {
    name: 'IntControlGroup',
    
    emits: ["controlCheckedUpdate"],
    
    components: { IntControlField },
    
    props: {
      options: { type: Array, required: true },
      value: { type: Array, required: true },
      labelledBy: { type: String, required: true },
      inline: { type: Boolean, default: false },
      name: { type: String },
      type: {
        type: String, default: 'checkbox',
        validator(val) {
          return ['checkbox', 'radio', 'toggle'].includes(val)
        }
      },
      disabled: { type: Boolean }
    },
  
    computed: {
      role() {
        return this.type === 'radio' ? 'radiogroup' : 'group'
      }
    },

    methods: {
        onChecked(opt, checked){
          let updatedValue = [...this.value]
            if (checked){ updatedValue.push(opt) }
            else { updatedValue.splice(updatedValue.indexOf(opt), 1) }
          
          this.$emit('controlCheckedUpdate', updatedValue)
        }
    }
  }
</script>